import { render, staticRenderFns } from "./SenderOverview.vue?vue&type=template&id=0e75dd58&"
import script from "./SenderOverview.vue?vue&type=script&lang=js&"
export * from "./SenderOverview.vue?vue&type=script&lang=js&"
import style0 from "./SenderOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports